// Actions
export const USER_FETCH  = '[User] Fetch'

// Mutations
export const USER_META   = '[User] meta'
export const USER_OBTAIN = '[User] obtain'
export const USER_CLEAR  = '[User] clear'
export const USER_SET_LOADING = '[User] set loading'
